import { zodResolver } from '@hookform/resolvers/zod'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { FormProvider, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import * as z from 'zod'

import {
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { Select } from '@/components/Form'

// Logic

//API
import useUser from '@/features/users/useUser'

//Slice
import useOfferAction from '@/features/offers/hooks/useOfferAction'
import { hideCloneOfferModal, selectCloneOfferModal } from '@/stores/offers/offersSlice'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//Constant

const CloneOfferModal = () => {
  const { show, isRenew, offerId, salesId, subSystemIndex } = useSelector(selectCloneOfferModal)

  // Hook
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { useUserOptions } = useUser()
  const { useCloneOffer, useRenewOffer } = useOfferAction()

  const cloneOffer = useCloneOffer()
  const renewOffer = useRenewOffer()

  const methods = useForm({
    resolver: zodResolver(
      z.object({
        salesId: z.string().min(1, { message: 'Please select a sales responsible to proceed.' }),
      })
    ),
  })

  //Translated Variables
  const { data: userOptions, isLoading: isLoadingUser } = useUserOptions({ labelKey: 'fullName', valueKey: '_id' })

  useEffect(() => {
    if (salesId) {
      methods.reset({ salesId: salesId })
    }
  }, [methods, salesId])

  const closeModal = () => {
    methods.reset({
      sales: '',
    })
    dispatch(hideCloneOfferModal())
  }

  const onSubmit = async ({ salesId }) => {
    try {
      dispatch(showLoadingOverlay())
      let res
      if (isRenew) {
        res = await renewOffer.mutateAsync({ offerId, salesId, subSystemIndex })
      } else {
        res = await cloneOffer.mutateAsync({ offerId, salesId })
      }

      const newOfferId = res?._id

      if (newOfferId && newOfferId !== '') {
        window.open(`/offers/${newOfferId}`, '_blank')
      }
    } catch (err) {
      console.log(err)
    } finally {
      dispatch(hideLoadingOverlay())

      closeModal()
    }
  }

  if (isLoadingUser) {
    return <></>
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW={'30%'}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalHeader>{isRenew ? 'Renew' : 'Clone'} Offer</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex direction={'column'} gap="4">
                <Select name="salesId" label="Sales Responsible" options={userOptions} isRow />
              </Flex>
            </ModalBody>

            <ModalFooter>
              <HStack>
                <Button colorScheme="green" type="submit">
                  {isRenew ? 'Renew' : 'Clone'}
                </Button>

                <Button colorScheme="gray" onClick={closeModal}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default CloneOfferModal
